import { Grid, SxProps, Typography } from '@mui/material';

import { Field } from '../Field';

type AddressFieldsProps = {
    heading: string;
    postalLabel: string;
    eircode?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    county?: string;
    country?: string;
    gridSx?: SxProps;
};
const AddressFields = ({
    heading,
    postalLabel,
    eircode,
    addressLine1,
    addressLine2,
    city,
    county,
    country,
    gridSx,
}: AddressFieldsProps) => {
    return (
        <>
            <Grid item xs={12} sx={gridSx}>
                <Typography sx={{ fontSize: '24px', fontWeight: 500 }}>{heading}</Typography>
            </Grid>

            <Field label={postalLabel} value={eircode} />
            <Grid item lg={6} xs={12} />
            <Field label="Address Line 1" value={addressLine1} />
            <Field label="Address Line 2" value={addressLine2} />
            <Field label="City" value={city} />
            <Field label="County" value={county} />
            <Field label="Country" value={country} />
        </>
    );
};

export default AddressFields;
